module.exports = __webpack_public_path__ + "img/large-1466557422-feature.3554c816.jpeg";